// extracted by mini-css-extract-plugin
module.exports = {"paymentMethods":"ProductPaymentMethods_paymentMethods__p1aVM","paymentIcon":"ProductPaymentMethods_paymentIcon__l3Zf3"};